import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

const mutation = graphql`
  mutation EditPolicyStartApprovalsMutation(
    $input: EditPolicyStartApprovalsInput!
  ) {
    editPolicyStartApprovals(input: $input) {
      ok
      reasons
      redirectUrl
    }
  }
`;

export const editPolicyStartApprovals = (
  environment,
  startApprovalsVariables,
  callback
) => {
  const variables = {
    input: startApprovalsVariables
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response, errors);
    },
    onError: err => {
      throw new Error(err);
    }
  });
};
